import base from './baseOptions';
import buildDrillDown from '../../../buildDrillDown';

// Packed bubble sizes each dimension member by a single metric's value. It
// reuses the name/value breakdown data (one series). Requires the
// highcharts-more module (already registered in Chart.tsx).
const packedBubble = ({
  formatMetric,
  title,
  openMenu,
  groupField,
  fieldType,
  chartDef,
  fontSize,
}) => ({
  ...base(formatMetric),
  chart: {
    ...base(formatMetric).chart,
    type: 'packedbubble',
  },
  title: {
    ...base(formatMetric).title,
    text: title,
  },
  legend: {
    ...base(formatMetric).legend,
    enabled: false,
  },
  plotOptions: {
    packedbubble: {
      minSize: '30%',
      maxSize: '120%',
      layoutAlgorithm: {
        gravitationalConstant: 0.05,
        splitSeries: false,
        seriesInteraction: false,
        dragBetweenSeries: false,
        parentNodeLimit: false,
      },
      dataLabels: {
        enabled: true,
        format: '{point.name}',
        style: {
          color: 'var(--color-text-primary)',
          textOutline: 'none',
          fontWeight: 'normal',
          fontSize,
        },
      },
      point: {
        events: {
          click: function (e) {
            const selectedIndex = e.point.index;
            const terms = e.point.series.data;
            if (openMenu) {
              const { metricIds } = this.series.userOptions;
              const selectedTerm = terms.find(
                (t, index) => index === selectedIndex,
              );
              if (!selectedTerm) {
                return;
              }
              openMenu(
                metricIds,
                buildDrillDown(
                  groupField,
                  fieldType,
                  selectedTerm.name,
                  chartDef,
                ),
              );
            } else {
              const { onDrillDown } = this.series.userOptions;
              if (!onDrillDown) {
                alert('Coming soon...');
                return;
              }
              const selectedTerm = terms.find(
                (t, index) => index === selectedIndex,
              );
              if (selectedTerm) {
                onDrillDown(selectedTerm.name, e.ctrlKey || e.metaKey);
              }
            }
          },
        },
      },
    },
  },
  tooltip: {
    ...base(formatMetric).tooltip,
    shared: false,
    useHTML: true,
    pointFormatter: function () {
      const value = formatMetric({
        metricId: this.series.userOptions.metricId,
        value: this.value,
      });
      // NOTE: Inline styles in Highcharts tooltips cannot use CSS variables.
      return `<span style="color:${this.color}">● </span><span style="color: var(--color-text-muted);">${this.name}: </span><b>${value}</b>`;
    },
  },
});

export default packedBubble;
